<template>
  <div
    class="check-kifu-step d-flex justify-content-between align-items-center"
  >
    <b-button
      variant="secondary"
      size="oval-sm"
      class="mr-md-0"
      :disabled="currentStep <= 0 || disableCurrentStep"
      @click="checkStep('prev')"
    >
      <span class="icon-Rewind"></span>
    </b-button>
    <span v-if="hasCurrentStep && $device.isMobile" class="currentStep">
      {{ currentStep || 0 }}
    </span>
    <span v-else-if="!$device.isMobile" class="currentStep w-100">{{
      (currentStep || 0) + '/' + (maxStep || 0)
    }}</span>
    <slot name="custom-step"></slot>
    <b-button
      variant="secondary"
      size="oval-sm"
      class="ml-md-0"
      :disabled="maxStep <= 0 || currentStep === maxStep || disableMaxStep"
      @click="checkStep('next')"
    >
      <span class="icon-Play"></span>
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'CheckKifuStep',
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
    maxStep: {
      type: Number,
      default: 0,
    },
    hasCurrentStep: {
      type: Boolean,
      default: false,
    },
    disableCurrentStep: {
      type: Boolean,
      default: false,
    },
    disableMaxStep: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    checkStep(direction) {
      this.$emit('check-step', direction);
    },
  },
};
</script>

<style lang="scss" scoped>
.check-kifu-step {
  border-radius: 10px;
  background: white;
  width: 100%;
  text-align: center;
  gap: 8px;
  @media screen and (min-width: 768px) {
    border-radius: 8px;
    gap: 16px;
  }

  .btn-secondary.disabled,
  .btn-secondary:disabled {
    background-color: #dcdfe5 !important;
  }
  .currentStep {
    line-height: 44px;
    background: $bgcontainer;
    border-radius: $rounded-sm;
    color: $font-grayscale-1;
    display: block;
    min-width: 54px;
    font-weight: 700;
    @media screen and (min-width: 768px) {
      width: 133px;
      background: $grayscale-2;
      border-radius: $rounded-md;
      line-height: 46px;
      font-weight: bold;
    }
  }
}
</style>
